import { render, staticRenderFns } from "./fieldButtonCancelCourseBooking.vue?vue&type=template&id=d6651a20&"
import script from "./fieldButtonCancelCourseBooking.vue?vue&type=script&lang=js&"
export * from "./fieldButtonCancelCourseBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6651a20')) {
      api.createRecord('d6651a20', component.options)
    } else {
      api.reload('d6651a20', component.options)
    }
    module.hot.accept("./fieldButtonCancelCourseBooking.vue?vue&type=template&id=d6651a20&", function () {
      api.rerender('d6651a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldButtonCancelCourseBooking.vue"
export default component.exports